var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAcessibleEverywhere(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "48px",
    viewBox: "0 0 50 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 23") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.5333 0.0911 38.011 0.0911 38.011 37.5681 0.5333 37.5681"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0 0 45.8176 0 45.8176 47.9999 0 47.9999"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Homepage",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Homepage---logged-out",
    transform: "translate(-768.000000, -2133.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-23",
    transform: "translate(768.000000, 2133.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(12.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0113,18.8301 C38.0113,29.1791 29.6213,37.5681 19.2723,37.5681 C8.9233,37.5681 0.5333,29.1791 0.5333,18.8301 C0.5333,8.4801 8.9233,0.0911 19.2723,0.0911 C29.6213,0.0911 38.0113,8.4801 38.0113,18.8301",
    id: "Fill-1",
    fill: "#E5F3EB",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19.6363,3.6357 L12.3643,3.6357 C11.9623,3.6357 11.6363,3.9607 11.6363,4.3637 C11.6363,4.7657 11.9623,5.0907 12.3643,5.0907 L19.6363,5.0907 C20.0383,5.0907 20.3643,4.7657 20.3643,4.3637 C20.3643,3.9607 20.0383,3.6357 19.6363,3.6357",
    id: "Fill-4",
    fill: "#1A171B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2745,44.3662 C23.6745,44.3662 24.0025,44.0392 24.0025,43.6382 C24.0025,43.2312 23.6745,42.9112 23.2745,42.9112 C22.8745,42.9112 22.5475,43.2312 22.5475,43.6382 C22.5475,44.0392 22.8745,44.3662 23.2745,44.3662",
    id: "Fill-6",
    fill: "#1A171B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0015,44.3662 C16.4015,44.3662 16.7295,44.0392 16.7295,43.6382 C16.7295,43.2312 16.4015,42.9112 16.0015,42.9112 C15.6015,42.9112 15.2745,43.2312 15.2745,43.6382 C15.2745,44.0392 15.6015,44.3662 16.0015,44.3662",
    id: "Fill-8",
    fill: "#1A171B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.729,44.3662 C9.129,44.3662 9.457,44.0392 9.457,43.6382 C9.457,43.2312 9.129,42.9112 8.729,42.9112 C8.322,42.9112 8.001,43.2312 8.001,43.6382 C8.001,44.0392 8.322,44.3662 8.729,44.3662",
    id: "Fill-10",
    fill: "#1A171B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.855,3.6357 C22.454,3.6357 22.128,3.9617 22.128,4.3637 C22.128,4.7657 22.454,5.0907 22.855,5.0907 C23.257,5.0907 23.583,4.7657 23.583,4.3637 C23.583,3.9617 23.257,3.6357 22.855,3.6357",
    id: "Fill-12",
    fill: "#1A171B"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-16"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0806,31.1729 C39.7086,32.4129 38.5886,33.2459 37.2936,33.2459 L34.9856,33.2459 L36.2946,20.1549 L37.4546,20.1549 L43.3866,20.1549 L40.0806,31.1729 Z M29.0216,33.2459 L27.7126,20.1549 L34.8326,20.1549 L33.5236,33.2459 L29.0216,33.2459 Z M30.5456,39.2729 L1.4546,39.2729 L1.4546,8.7279 L30.5456,8.7279 L30.5456,13.2999 L30.4916,13.2999 C27.3586,13.2999 24.7726,15.6629 24.4106,18.6999 L18.1816,18.6999 L17.4546,18.6999 C17.0536,18.6999 16.7266,19.0259 16.7266,19.4279 C16.7266,19.8299 17.0536,20.1549 17.4546,20.1549 L17.6406,20.1549 L21.0716,31.5909 C21.6296,33.4509 23.3096,34.6999 25.2516,34.6999 L28.3636,34.6999 L30.5456,34.6999 L30.5456,39.2729 Z M30.5456,43.6849 C30.5456,45.2619 29.2626,46.5449 27.6846,46.5449 L4.3146,46.5449 C2.7376,46.5449 1.4546,45.2619 1.4546,43.6849 L1.4546,40.7269 L30.5456,40.7269 L30.5456,43.6849 Z M1.4546,4.3159 C1.4546,2.7369 2.7376,1.4539 4.3146,1.4539 L27.6846,1.4539 C29.2626,1.4539 30.5456,2.7369 30.5456,4.3159 L30.5456,7.2729 L1.4546,7.2729 L1.4546,4.3159 Z M25.8746,18.6999 C26.2246,16.4679 28.1626,14.7539 30.4916,14.7539 L30.5456,14.7539 L30.5456,18.6999 L26.9096,18.6999 L25.8746,18.6999 Z M25.0906,20.1549 L26.2506,20.1549 L27.5596,33.2459 L25.2516,33.2459 C23.9566,33.2459 22.8366,32.4129 22.4656,31.1729 L19.1596,20.1549 L25.0906,20.1549 Z M32.0536,14.7539 C34.3836,14.7539 36.3206,16.4679 36.6706,18.6999 L35.6366,18.6999 L31.9996,18.6999 L31.9996,14.7539 L32.0536,14.7539 Z M45.0906,18.6999 L44.3636,18.6999 L38.1346,18.6999 C37.7726,15.6629 35.1856,13.2999 32.0536,13.2999 L31.9996,13.2999 L31.9996,4.3159 C31.9996,1.9359 30.0636,-0.0001 27.6846,-0.0001 L4.3146,-0.0001 C1.9356,-0.0001 -0.0004,1.9359 -0.0004,4.3159 L-0.0004,43.6849 C-0.0004,46.0649 1.9356,47.9999 4.3146,47.9999 L27.6846,47.9999 C30.0636,47.9999 31.9996,46.0649 31.9996,43.6849 L31.9996,34.6999 L34.1816,34.6999 L37.2936,34.6999 C39.2356,34.6999 40.9156,33.4509 41.4736,31.5909 L44.9046,20.1549 L45.0906,20.1549 C45.4926,20.1549 45.8176,19.8299 45.8176,19.4279 C45.8176,19.0259 45.4926,18.6999 45.0906,18.6999 L45.0906,18.6999 Z",
    id: "Fill-14",
    fill: "#1A171B",
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.0757,21.6094 C14.0757,21.2084 13.7497,20.8824 13.3477,20.8824 L5.3477,20.8824 C4.9467,20.8824 4.6207,21.2084 4.6207,21.6094 C4.6207,22.0114 4.9467,22.3374 5.3477,22.3374 L13.3477,22.3374 C13.7497,22.3374 14.0757,22.0114 14.0757,21.6094",
    id: "Fill-17",
    fill: "#1A171B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5303,26.7012 C15.5303,26.2992 15.2043,25.9732 14.8033,25.9732 L6.8023,25.9732 C6.4013,25.9732 6.0753,26.2992 6.0753,26.7012 C6.0753,27.1022 6.4013,27.4282 6.8023,27.4282 L14.8033,27.4282 C15.2043,27.4282 15.5303,27.1022 15.5303,26.7012",
    id: "Fill-19",
    fill: "#1A171B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2574,31.0635 L8.2574,31.0635 C7.8564,31.0635 7.5304,31.3885 7.5304,31.7915 C7.5304,32.1925 7.8564,32.5185 8.2574,32.5185 L16.2574,32.5185 C16.6594,32.5185 16.9854,32.1925 16.9854,31.7915 C16.9854,31.3885 16.6594,31.0635 16.2574,31.0635",
    id: "Fill-21",
    fill: "#1A171B"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcessibleEverywhere);
export default __webpack_public_path__ + "static/media/acessible-everywhere.af76293e906eb096d381a44ed94556ac.svg";
export { ForwardRef as ReactComponent };